export const baseurl = (process.env.NODE_ENV === "development")? 'http://localhost:3001' : 'https://dwdata.onrender.com';